import React, { Dispatch, SetStateAction } from 'react'

import { Editor } from '@tinymce/tinymce-react'

interface IRichTextEditorProps {
  value: string
  setValue: Dispatch<SetStateAction<string>>
}

const RichTextEditor = ({ value, setValue }: IRichTextEditorProps) => {
  return (
    <div>
      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        licenseKey="gpl"
        value={value}
        onEditorChange={setValue}
        init={{
          plugins: 'link',
          toolbar: 'link',
          menubar: 'insert',
          default_link_target: '_blank',
          link_assume_external_targets: true,
          promotion: false,
        }}
      />
    </div>
  )
}

export default RichTextEditor
